// extracted by mini-css-extract-plugin
export var accordeon_answers = "accordeon-module--accordeon_answers--0HgMM";
export var accordion_content = "accordeon-module--accordion_content--d4Ue6";
export var active = "accordeon-module--active--eE-uK";
export var circle_plus = "accordeon-module--circle_plus--KX-d-";
export var collapsed = "accordeon-module--collapsed--W2-Iz";
export var faq_accordeon = "accordeon-module--faq_accordeon--4s77t";
export var title = "accordeon-module--title--sm7pj";